import { render, staticRenderFns } from "./AdvisoryCouncil.vue?vue&type=template&id=297bb2b3&"
import script from "./AdvisoryCouncil.vue?vue&type=script&lang=js&"
export * from "./AdvisoryCouncil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports